export const TESTING = process.env.REACT_APP_TESTING === 'true';
export const MAX_NUMBER_OF_PARTICIPANTS = 5000;
